<template>
  <div class="c-seasons-sidebar__episode">
    <div class="c-seasons-sidebar__episode-wrapper">
      <v-product-image
        :product="episode"
        class="c-seasons-sidebar__episode-image"
      ></v-product-image>
      <v-play-product
        :product="episode"
        icon-class="o-icon--play-circle o-icon--xlarge"
        class="o-button--overlay"
      ></v-play-product>
      <v-progress
        :product="episode"
        class="c-seasons-sidebar__episode-progress"
      ></v-progress>
    </div>
    <div>
      <h2 class="c-seasons-sidebar__episode-title">
        {{ episode.title }}
      </h2>
      <p class="o-typography__subtitle2">
        {{ episode | meta(['episode', 'duration']) }}
      </p>
      <p>
        {{ episode.lead | truncate(80) }}
      </p>
    </div>
  </div>
</template>
<script>
  import VPlayProduct from '@/index/shared/components/play-product/index.vue';
  import VProductImage from '@/index/shared/components/product-image/index.vue';
  import VProgress from '@/index/shared/components/progress/index.vue';
  import { meta, truncate } from '@/index/shared/filters';

  export default {
    name: 'UiPlayerSeasonsEpisode',
    components: {
      VPlayProduct,
      VProductImage,
      VProgress,
    },
    filters: {
      meta,
      truncate,
    },
    props: {
      episode: Object,
    },
  };
</script>
